import { combineReducers } from '@reduxjs/toolkit';
import invite, { InviteState } from './inviteReducer';
import requests, { CommonsRequestStore } from './requestReducer';
import user, { UserState } from './userReducer';

export type Store = {
    invite: InviteState;
    requests: CommonsRequestStore;
    user: UserState;
};

const rootReducer = combineReducers({
    invite,
    requests,
    user,
});

export default rootReducer;
